import styled from '@emotion/styled';
import { color, COLOR_VARIANTS } from '@tajawal/ct-web-design-system';
import { shouldForwardProp } from '@/utils/style.utils';

const Wrapper = styled('div', { shouldForwardProp })<{ $isDesktop: boolean }>`
  border-radius: 12px;
  padding: ${({ $isDesktop }) => ($isDesktop ? '16px 8px' : '16px')};
  border: 1px solid ${color(COLOR_VARIANTS.GAINSBORO)};
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-grow: 1;
  height: 64px;
`;

const FlexWrapper = styled('div')`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export default {
  Wrapper,
  FlexWrapper,
};
